import { Component, Input, OnChanges, signal, SimpleChanges, ViewChild, WritableSignal } from '@angular/core';
import { ExpandableAreaComponent } from 'ids-enterprise-ng';

@Component({
  selector:    'lm-report-facade-report-template-panel',
  standalone: false,
  templateUrl: './lm-facade-report-template-panel.component.html',
  styleUrl: './lm-facade-report-template-panel.component.scss',
})
export class LMFacadeReportTemplatePanelComponent implements OnChanges {

  @Input() label: string | undefined;
  @Input() fields: Array<LMFacadeReportTemplateField> = [];
  @Input() listFilter: string | undefined;
  @Input() reportFilter: string | undefined;
  @Input() sortBy: LMFacadeSetSpec | undefined;

  // @ViewChild(ExpandableAreaComponent) expandableArea: ExpandableAreaComponent | undefined;

  // private defaultButtonIcon = 'chevron-up';
  // buttonIcon = signal(this.defaultButtonIcon);
  private defaultFilterDisplayFields: Array<LMFacadeListFilterFieldUI> = [];
  displayedFilterFields: WritableSignal<Array<LMFacadeListFilterFieldUI>> = signal(this.defaultFilterDisplayFields);
  private defaultDisplayFields: Array<LMFacadeReportTemplateField> = [];
  displayedFields: WritableSignal<Array<LMFacadeReportTemplateField>> = signal(this.defaultDisplayFields);

  private open = true;

  constructor() { }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.listFilter || changes.reportFilter) {
      this.buildFilterFields();
    }
    if (changes.fields && this.fields && this.fields.length > 0) {
      this.buildFields();
    }
  }

  // toggleHeaders($event: Event) {
  //   $event.stopPropagation();
  //   $event.stopImmediatePropagation();
  //   if (this.expandableArea) {
  //     if (this.open) {
  //       this.expandableArea.close();
  //       this.open = false;
  //     } else {
  //       this.expandableArea.open();
  //       this.open = true;
  //     }
  //     this.setIcon();
  //   }
  // }
  //
  // setIcon() {
  //   if (this.open) {
  //     this.buttonIcon.set('chevron-up');
  //   } else {
  //     this.buttonIcon.set('chevron-down');
  //   }
  // }

  private buildFilterFields() {
    if (this.listFilter) {
      const listFilterArray = this.listFilter.split(' and ');
      const listFilterFormattedArray: Array<LMFacadeListFilterFieldUI> = [];
      listFilterArray.forEach((entry: string, index: number) => {
        if (entry.indexOf(' or ') > -1) {
          const orArray = entry.split(' or ');
          orArray.forEach((entry2: string, index2: number) => {
            listFilterFormattedArray.push(this.buildFilterField(entry2, index2, false));
            if (index2 !== orArray.length - 1)
              listFilterFormattedArray.push({ id: 'or_list_filter_' + index2, or: true });
          });
        } else {
          listFilterFormattedArray.push(this.buildFilterField(entry, index, true));
        }
        if (index !== listFilterArray.length - 1)
          listFilterFormattedArray.push({ id: 'and_list_filter_' + index, and: true });
      });
      const reportFilterFormattedArray: Array<LMFacadeListFilterFieldUI> = [];
      if (this.reportFilter) {
        reportFilterFormattedArray.push({ id: 'and_Filter_Report_Sep', and: true });
        const reportFilterArray = this.reportFilter.split(' and ');
        reportFilterArray.forEach((entry: string, index: number) => {
          if (entry.indexOf(' or ') > -1) {
            const orArray = entry.split(' or ');
            orArray.forEach((entry2: string, index2: number) => {
              reportFilterFormattedArray.push(this.buildFilterField(entry2, index2, false));
              if (index2 !== orArray.length - 1)
                reportFilterFormattedArray.push({ id: 'or_report_filter_' + index2, or: true });
            });
          } else {
            reportFilterFormattedArray.push(this.buildFilterField(entry, index, false));
          }
          if (index !== reportFilterArray.length - 1)
            reportFilterFormattedArray.push({ id: 'and_report_filter_' + index, and: true });
        });
      }

      this.displayedFilterFields.set([ ... listFilterFormattedArray, ... reportFilterFormattedArray ]);
    }
  }

  private buildFilterField(entry: string, index: number, fromListFilter: boolean): LMFacadeListFilterFieldUI {
    if (entry.indexOf('(') > -1)
      entry = entry.replace('(', '');
    if (entry.indexOf(')') > -1)
      entry = entry.replace(')', '');
    if (entry.indexOf(' = ')> -1)
      entry = entry.replace('=', ' equals: ');
    if (entry.indexOf(' != ')> -1)
      entry = entry.replace('!=', ' does not equal: ');

    entry = entry.trim();

    let id = '';
    if (fromListFilter)
      id = entry + '_list_filter_' + index;
    else
      id = entry + '_report_filter_' + index;

    return { id, label: entry };
  }

  private buildFields() {
    const tempFields: Array<LMFacadeReportTemplateField> = [];
    this.fields.forEach((field: LMFacadeReportTemplateField) => {
      tempFields.push({
        name: field.name,
        type: field.type,
        icon: this.getBuilderFieldIcon(field),
        tooltip: this.getBuilderFieldTypeTooltip(field)
      });
    });
    this.displayedFields.set(tempFields);
  }

  private getBuilderFieldIcon(facadeField: LMFacadeReportTemplateField): string {
    // if (facadeField.uiFieldSpec.isKeyField) {
    //   return 'key';
    // }
    switch (facadeField.type) {
      case 'boolean':
        return 'check-list';
      case 'number':
        return 'number';
      case 'date':
        return 'calendar';
      default:
        return 'change-font';
    }
  }

  private getBuilderFieldTypeTooltip(facadeField: LMFacadeReportTemplateField): string {
    // if (facadeField.uiFieldSpec.isKeyField) {
    //   return 'Key Field';
    // }
    switch (facadeField.type) {
      case 'boolean':
        return 'True or False';
      case 'number':
        return 'Number';
      case 'date':
        return 'Date or Time';
      default:
        return 'Text';
    }
  }
}

interface LMFacadeListFilterFieldUI {
  id: string;
  label?: string;
  and?: boolean;
  or?: boolean;
}
